<template>
    <div>
        <!-- Toolbar -->
        <div class="d-flex flex-row justify-content-end">
            <div>
                <AddFtpAccountModalButton v-if="Permission.CREATE_FTP_ACCOUNT"/>
            </div>
        </div>

        <!-- Table -->
        <div class="card card-body">
            <table v-if="accounts.length" class="table table-hover table-vertical-center">
                <thead>
                <tr>
                    <th>{{ __('general.ftp.user') }}</th>
                    <th>{{ __('general.ftp.password') }}</th>
                    <th class="text-center w-100px">{{ __('general.protected') }}</th>
                    <th class="text-center w-100px">{{ __('general.files') }}</th>
                    <th class="text-center w-200px">{{ __('general.last_change') }}</th>
                    <th class="text-right">{{ __('general.actions') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="account in accounts">
                    <td>
                        {{ account.username }}
                    </td>
                    <td class="text-monospace">
                        <HiddenText :value="account.password"/>
                    </td>
                    <td class="text-center">
                        <i v-if="account.protected"
                           class="fas fa-lock"
                           :title="__('general.protected')"
                        />
                        <span v-else class="text-muted">
                            -
                        </span>
                    </td>
                    <td class="text-center">
                        {{ account.files }}
                    </td>
                    <td class="text-center">
                        <div v-if="account.last_upload_at">
                            {{ $localDateTime(account.last_upload_at) }}
                        </div>
                        <div v-else>
                            {{ __('general.no_files') }}
                        </div>
                    </td>
                    <td>
                        <div class="d-flex flex-row justify-content-end align-items-center">
                            <a :href="$route('ftp.accounts.files', {username: account.username})" title="Dateien"
                               class="btn btn-sm btn-clean btn-icon btn-hover-light-primary">
                                <i class="fas fa-folder-open"/>
                            </a>
                            <button v-if="Permission.DELETE_FTP_ACCOUNT"
                                    :title="account.protected ? 'This account is protected against deletion.' : __('actions.delete')"
                                    class="btn btn-sm btn-clean btn-icon btn-hover-light-danger"
                                    :disabled="account.protected"
                                    @click="deleteAccount(account.username)">
                                <i class="fas fa-trash"/>
                            </button>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <div v-else class="text-muted text-center">
                {{ __('general.things.none_present_yet', {things: __('general.ftp.accounts')}) }}
            </div>
        </div>
    </div>
</template>

<script>
import {PermissionsMixin} from '@js/permissions';
import AddFtpAccountModalButton from "@pages/FTP/Components/AddFtpAccountModalButton";
import HiddenText from "@components/Form/HiddenText.vue";

export default {
    mixins: [PermissionsMixin],

    components: {
        AddFtpAccountModalButton,
        HiddenText
    },

    props: {
        accounts: Array,
    },

    methods: {
        deleteAccount(username) {
            Swal.fire({
                title: `Delete ${username}?`,
                text: 'All data will be deleted! This can not be undone.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#ea4b4b',
                confirmButtonText: 'Delete',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$inertia.delete(this.$route('ftp.accounts.delete'), {
                        data: {
                            username: username
                        }
                    })
                }
            });
        },
    },
};
</script>
